module.exports = __webpack_public_path__ + "static/media/circuit.ca156cfe.svg";